export default __webpack_public_path__ + "static/media/WearAndTearThumbnail.83661983.webp";